import { SlideShop } from "../utilities/slideShopCards";
class shop {
    constructor() {
        this.elemts = '#shop-item-0 .abi__shop-collection-list-item-card-images';
        this.initPageConfig();
    }
    initPageConfig() {
        const Slide = document.querySelectorAll(".abi__shop-collection-list-item-card");
        if (Slide) {
            Slide.forEach(slide => {
                if (slide) {
                    const parentSlide = slide.getAttribute("id");
                    const containerVideo = new SlideShop(`#${parentSlide} .abi__shop-collection-list-item-card-images`, (() => {
                        const shopLink = document.querySelector(`#${parentSlide} .abi__shop-collection-list-item-card-link`);
                        if (shopLink) {
                            if (window.innerWidth > 768) {
                                shopLink.addEventListener('mouseenter', function () {
                                    var _a;
                                    const slideActive = (_a = this.parentElement) === null || _a === void 0 ? void 0 : _a.getAttribute("id");
                                    const slides = document.querySelectorAll(`#${slideActive} .abi__shop-collection-list-item-card-images`);
                                    containerVideo.onChange(slides);
                                });
                            }
                            else {
                                let enterView = 0;
                                let outView = 0;
                                let interval;
                                document.addEventListener("scroll", (event) => {
                                    var _a;
                                    if (elementInView(shopLink)) {
                                        if (enterView === 0) {
                                            const slideActive = (_a = shopLink.parentElement) === null || _a === void 0 ? void 0 : _a.getAttribute("id");
                                            const slides = document.querySelectorAll(`#${slideActive} .abi__shop-collection-list-item-card-images`);
                                            setTimeout(() => {
                                                interval = setInterval(() => {
                                                    slides.length > 1 && containerVideo.onChange(slides);
                                                }, 1600);
                                            }, 400);
                                        }
                                        enterView = enterView + 1;
                                    }
                                    else if (elementOutofView(document.querySelector(".abi__shop-collection-list"))) {
                                        if (outView === 0) {
                                            clearInterval(interval);
                                            enterView = 0;
                                        }
                                    }
                                });
                            }
                        }
                    }), false);
                    containerVideo.onInit();
                }
            });
        }
        const elementInView = (el, dividend = 1) => {
            const elementTop = el.getBoundingClientRect().top;
            return (elementTop <=
                (window.innerHeight || document.documentElement.clientHeight) / dividend);
        };
        const elementOutofView = (el) => {
            const elementTop = el.getBoundingClientRect().top;
            return (elementTop > (window.innerHeight || document.documentElement.clientHeight));
        };
    }
}
window.addEventListener('load', function () {
    new shop();
});
